var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "29px",
    viewBox: "0 0 38 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assessment-Big@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Modal",
    transform: "translate(-951.000000, -545.000000)",
    fill: "#5B65DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Assessment",
    transform: "translate(818.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.058824,59.7692308 L162.058824,45.2692308 C162.058824,44.6532211 162.559211,44.1538462 163.176471,44.1538462 L167.647059,44.1538462 C168.264318,44.1538462 168.764706,44.6532211 168.764706,45.2692308 L168.764706,59.7692308 L169.882353,59.7692308 C170.499612,59.7692308 171,60.2686057 171,60.8846154 C171,61.500625 170.499612,62 169.882353,62 L134.117647,62 C133.500388,62 133,61.500625 133,60.8846154 C133,60.2686057 133.500388,59.7692308 134.117647,59.7692308 L135.235294,59.7692308 L135.235294,43.0384615 C135.235294,42.4224519 135.735682,41.9230769 136.352941,41.9230769 L140.823529,41.9230769 C141.440789,41.9230769 141.941176,42.4224519 141.941176,43.0384615 L141.941176,59.7692308 L144.176471,59.7692308 L144.176471,34.1153846 C144.176471,33.499375 144.676859,33 145.294118,33 L149.764706,33 C150.381965,33 150.882353,33.499375 150.882353,34.1153846 L150.882353,59.7692308 L153.117647,59.7692308 L153.117647,39.6923077 C153.117647,39.0762981 153.618035,38.5769231 154.235294,38.5769231 L158.705882,38.5769231 C159.323141,38.5769231 159.823529,39.0762981 159.823529,39.6923077 L159.823529,59.7692308 L162.058824,59.7692308 Z",
    id: "Assessment-Big"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment_icon.476010df00ec5c6fca80577413a152a9.svg";
export { ForwardRef as ReactComponent };